<template>
  <div v-observe-visibility="visibilityChanged">
    <v-layout row justify-center>
      <v-dialog v-model="removeDialog" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Delete item?</v-card-title>
          <v-card-text>This action deletes selected item from Database, be carefull!</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary darken-1" flat @click.native="removeDialog = false">Cancel</v-btn>
            <v-btn color="primary darken-1" flat
                   @click.native="removeItem(itemToDelete)">OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 md6 lg3 pa-4 mt-3>
        <v-hover>
          <v-card slot-scope="{ hover }"
                  :class="`elevation-${hover ? 4 : 1}`">
            <v-flex xs12>
              <v-flex xs12 pt-4 pb-3 pr-2 pl-4>
                <span class="title">Brand Branch Offices</span>
              </v-flex>
              <v-divider/>
              <v-progress-linear class="branch-office-loading" :active="loading"
                                 :indeterminate="true"/>
            </v-flex>
            <v-list class="branchOfficesList" two-line subheader>
              <template v-for="(item, index) in items">
                <v-list-tile ripple avatar
                             @click="editItem(index)">
                  <v-list-tile-avatar>
                    <v-icon>business_center</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{item.name}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>{{item.taxnumber}} - {{item.country}} - {{item.city}} -
                      {{item.zipcode}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn icon ripple @click="showDeleteDialog(index, 'branchOffice')">
                      <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider/>
              </template>
            </v-list>
            <v-flex v-if="items == null || items.length <= 0">
              <v-card-text><p class="text-xs-center grey--text">No Brand Branch Offices yet</p>
              </v-card-text>
            </v-flex>
            <v-card-actions>
              <v-spacer/>
              <v-btn mt-5 dark color="secondary" @click="addNewItem">Add
                <v-icon class="white--text" right>add</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-flex>

      <v-flex xs12 md12 lg9 pa-4 mt-3>

        <v-hover>
          <v-card v-show="!formDisabled"
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 4 : 1}`">
            <v-layout wrap>
              <v-flex xs12 md4 pt-2 pl-4 pr-4>
                <v-layout wrap>
                  <v-flex xs12 pt-3 pb-2>
                    <span class="title">General</span>
                    <v-divider/>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.name"
                                  label="Name">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.taxnumber"
                                  label="Tax Number">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.vat"
                                  label="VAT Number">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.district_court"
                                  label="District Court">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.commercial_register_number"
                                  label="Commercial Register Number">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      color="secondary" label="Default"
                      v-model="selectedItem.default"/>
                  </v-flex>

                  <v-flex xs12>
                    <v-layout row>
                      <v-flex xs11>
                        <v-autocomplete
                          :items="mailSettings"
                          label="Mail Settings"
                          v-model="selectedItem.brand_configurations_mail_settings_id"
                          :loading="loading"
                          hide-details
                          item-value="id"
                          item-text="name"
                        />
                      </v-flex>
                      <v-flex xs1 mt-3>
                        <v-btn
                          icon small flat
                          @click="resetMailSettings()">
                          <v-icon color="grey">clear</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout row>
                      <v-flex xs11>
                        <v-autocomplete
                          :items="shopifySettings"
                          label="Shopify Settings"
                          v-model="selectedItem.brand_configurations_shopify_settings_id"
                          :loading="loading"
                          hide-details
                          item-value="id"
                          item-text="name"
                        />
                      </v-flex>
                      <v-flex xs1 mt-3>
                        <v-btn
                          icon small flat
                          @click="resetShopifySettings()">
                          <v-icon color="grey">clear</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 md4 pt-2 pl-4 pr-4>
                <v-layout wrap>
                  <v-flex xs12 pt-3 pb-2>
                    <span class="title">Address</span>
                    <v-divider/>
                  </v-flex>
                  <v-flex md8 xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.street"
                                  label="Street">
                    </v-text-field>
                  </v-flex>
                  <v-flex offset-md1 md3 xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.hnumber"
                                  label="House number">
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-layout wrap>
                      <v-flex xs4 pr-3>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedItem.zipcode"
                                      label="Postcode">
                        </v-text-field>
                      </v-flex>

                      <v-flex xs8 pr-0>
                        <v-text-field :disabled="formDisabled"
                                      v-model="selectedItem.city"
                                      label="City">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12>
                    <v-autocomplete :disabled="formDisabled"
                                    :items="countries"
                                    label="Country"
                                    v-model="selectedItem.country"
                                    required
                    />
                  </v-flex>

                </v-layout>
              </v-flex>
              <v-flex xs12 md4 pt-2 pl-4 pr-4>
                <v-layout wrap>
                  <v-flex xs12 pt-3 pb-2>
                    <span class="title">Bank Details</span>
                    <v-divider/>
                  </v-flex>

                  <v-flex md12 xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.iban_currency"
                                  label="Currency">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.iban"
                                  label="IBAN">
                    </v-text-field>
                  </v-flex>
                  <v-flex md12 xs12>
                    <v-text-field :disabled="formDisabled"
                                  v-model="selectedItem.swift"
                                  label="SWIFT">
                    </v-text-field>
                  </v-flex>

                  <v-btn
                    @click="createNewBankAccount"
                    class="mx-2"
                    fab
                    dark
                    small
                    color="primary"
                  >
                    <v-icon class="icon-padding" v-html="'fa-solid fa-plus'"></v-icon>
                  </v-btn>

                  <v-flex class="accountSection" md12 xs12
                          v-bind:key="item.iban"
                          v-for="(item, index) in allBankAccounts">

                    <v-btn
                      @click="showDeleteDialog(item, 'bankAccount')"
                      class="mx-2 remove-bank-account"
                      fab
                      dark
                      small
                      color="primary"
                    >
                      <v-icon class="icon-padding" v-html="'fa-solid fa-minus'"></v-icon>
                    </v-btn>

                    <v-btn
                      @click="saveBankAccount(item)"
                      class="mx-2 add-bank-account"
                      fab
                      dark
                      small
                      color="primary"
                    >
                      <v-icon class="icon-padding" v-html="'fa-solid fa-check'"></v-icon>
                    </v-btn>

                    <v-text-field :disabled="formDisabled"
                                  v-model="item.name"
                                  label="NAME">
                    </v-text-field>

                    <v-text-field :disabled="formDisabled"
                                  v-model="item.currency"
                                  label="CURRENCY">
                    </v-text-field>

                    <v-text-field :disabled="formDisabled"
                                  v-model="item.iban"
                                  label="IBAN">
                    </v-text-field>

                    <v-text-field :disabled="formDisabled"
                                  v-model="item.swift"
                                  label="SWIFT / ROUTING">
                    </v-text-field>

                  </v-flex>

                </v-layout>
              </v-flex>

            </v-layout>
            <v-card-actions>
              <v-spacer/>
              <v-btn :disabled="formEdited" mt-5 class="secondary white--text"
                     @click.native="saveAndGoToNextTab(3)">Save
                <v-icon class="white--text" right>save</v-icon>
              </v-btn>
            </v-card-actions>

          </v-card>
        </v-hover>

      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import {
  BrandConfigurationBranchOffice,
  BrandConfigurationMailSetting,
  BrandConfigurationShopifySettings,
  BrandConfiguration,
  Settings
} from '../../../store/namespace-helper'

export default {
  components: {},
  name: 'brand-configuration-branch-offices',
  data () {
    return {
      countries: this.$store.getters.countries,
      isVisible: false,
      removeDialog: false,
      removeType: '',
      removeBankAccountItem: null,
      itemToDelete: null,
      onDismissed: false,
      formUpdated: 0,
      formDisabled: true,
      uploadedDocument: null
    }
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab visible, load data')
          this.loadMailSettings()
          this.loadShopifySettings()
          this.loadItems()
          this.loadBankAccounts()
        } else {
          this.formDisabled = true
          this.formUpdated = 0
          this.$store.dispatch(BrandConfigurationBranchOffice.actions.setSelectedBrandConfigurationBranchOffice, null)
          console.log('Brand Branch Offices not visible!!!')
        }
      }
    },
    removeBankAccount (item) {
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.removeBranchOfficeBankAccountFromBrandConfiguration, item)
    },
    saveBankAccount (item) {
      item.brand_configurations_branch_office_id = this.selectedItem.id
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.saveOrUpdateAdditionalBankAccount, item)
    },
    loadItems () {
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.loadBrandConfigurationBranchOffices)
    },
    loadBankAccounts () {
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.loadAllBrandConfigurationBranchOfficesBankAccounts)
    },
    loadMailSettings () {
      this.$store.dispatch(BrandConfigurationMailSetting.actions.loadBrandConfigurationMailSettings)
    },
    loadShopifySettings () {
      this.$store.dispatch(BrandConfigurationShopifySettings.actions.loadBrandConfigurationShopifySettings)
    },
    editItem (index) {
      this.formDisabled = false
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.setSelectedBrandConfigurationBranchOffice, this.items[index])
    },
    showDeleteDialog (index, type) {
      this.removeDialog = true
      this.removeType = type
      if (type === 'branchOffice') {
        this.itemToDelete = index
      }
      if (type === 'bankAccount') {
        this.removeBankAccountItem = index
      }
    },
    removeItem (index) {
      if (this.removeType === 'branchOffice') {
        this.$store.dispatch(BrandConfigurationBranchOffice.actions.removeBranchOffice, this.itemToDelete)
        this.formUpdated = 0
        this.formDisabled = true
      }
      if (this.removeType === 'bankAccount') {
        this.removeBankAccount(this.removeBankAccountItem)
      }
      this.removeDialog = false
    },

    addNewItem () {
      let item = {
        id: null,
        name: 'New Brand Branch Office',
        country: null,
        zipcode: null,
        city: null,
        hnumber: null,
        street: null,
        taxnumber: null,
        vat: null,
        district_court: null,
        iban: null,
        iban_currency: null,
        swift: null,
        commercial_register_number: null,
        default: false,
        brand_configurations_id: this.selectedBrandConfiguration.id
      }
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.setSelectedBrandConfigurationBranchOffice, item)
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.addNewBranchOffice, item)
    },
    createNewBankAccount () {
      let item = {
        name: '',
        currency: '',
        iban: '',
        swift: ''
      }

      this.$store.dispatch(BrandConfigurationBranchOffice.actions.addNewBankAccountToBrandConfiguration, item)
    },
    saveAndGoToNextTab (index) {
      this.$store.dispatch(BrandConfigurationBranchOffice.actions.saveBrandConfigurationBranchOffice, [this.selectedItem])
      this.formUpdated = 0
    },
    resetShopifySettings () {
      this.selectedItem.brand_configurations_shopify_settings_id = null
    },
    resetMailSettings () {
      this.selectedItem.brand_configurations_mail_settings_id = null
    }

  },
  computed: {
    selectedItem () {
      return this.$store.getters[BrandConfigurationBranchOffice.getters.getSelectedBrandConfigurationBranchOffice]
    },
    selectedBrandConfiguration () {
      return this.$store.getters[BrandConfiguration.getters.getSelectedBrandConfiguration]
    },
    items () {
      return this.$store.getters[BrandConfigurationBranchOffice.getters.brandConfigurationBranchOffices]
    },
    allBankAccounts () {
      return this.$store.getters[BrandConfigurationBranchOffice.getters.getAllBrandConfigurationBranchOfficesBankAccounts]
    },
    mailSettings () {
      return this.$store.getters[BrandConfigurationMailSetting.getters.brandConfigurationMailSettings]
    },
    shopifySettings () {
      return this.$store.getters[BrandConfigurationShopifySettings.getters.brandConfigurationShopifySettings]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    formEdited () {
      return this.formUpdated < 1
    }
  },
  watch: {
    selectedItem: {
      handler (val) {
        console.log('form data changed: ' + JSON.stringify(val))
        this.formUpdated++
      },
      deep: true
    }

  }
}
</script>

<style scoped>

  .remove-bank-account {
    position: absolute;
    right: 0;
  }

  .add-bank-account {
    position: absolute;
    right: 0;
    margin: 50px;
  }

  .accountSection {
    border: 2px solid gray;
    padding: 10px;
    margin: 5px;
  }

  .branchOfficesList {
    max-height: 50vh;
    overflow: scroll;
    margin-top: -20px;
  }

  .branchOfficesList::-webkit-scrollbar {
    display: none;
  }

  .branch-office-loading {
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/BrandConfiguration/BrandConfigurationBranchOffices.vue